import vars from '../../vars';

var bodyNode = document.getElementsByTagName('body')[0];

function openModal(textArr) {
	bodyNode.classList.add('fixed-position-modal');
	vars.$modalExponat.css("top", ($(window).scrollTop() + 5) + "px");
	vars.$modalExponat.removeClass('hide');
	vars.$overlay.removeClass('hide');
	$(window).trigger('resize');
	setTimeout(() => {
		$('.js-modal-game-slider img').show();
		$('.js-modal-game-slider .b-modal-slider__title').show();
		$('.js-modal-game-slider .b-modal-slider__text').show();
		if ($(window).width() >= 700) {
			for (var i = 0; i < textArr.length; i++) {
				$('.b-masonry__text').eq(i).text(textArr[i]);
			}
			$('.b-masonry__text').truncateText();
		}
	}, 300);
	if ($('.b-modal-slider__item').length < 2) {
		$('.slick-arrow').hide();
		$('.slick-dots').hide();
	}
}

$(document).ready(function() {
	if ($(window).width() >= 700) {
		var textArr = [];
		$('.b-masonry__text').each(function() {
			textArr.push($(this).text());
		});
	}

	vars.$overlay.on('click', (e) => {
		vars.$modalExponat.addClass('hide');
		vars.$overlay.addClass('hide');
		bodyNode.classList.remove('fixed-position-modal');
	});

	vars.$btnClose.on('click', (e) => {
		vars.$modalExponat.addClass('hide');
		vars.$overlay.addClass('hide');
		bodyNode.classList.remove('fixed-position-modal');
	});

	vars.$modalExponatClose.on('click', (e) => {
		vars.$modalExponat.addClass('hide');
		vars.$overlay.addClass('hide');
		bodyNode.classList.remove('fixed-position-modal');
	});

	if($(".b-white-page").height() > 0) {
		openModal(textArr);
	}

	$(".js-open-exponat-modal").on('click', (e) => {
		openModal(textArr);
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/one-exponat/modal-exponat.js